<template>
  <div>
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
      style="height: 50vh;"
    >
      <b-spinner label="Loading..." />
    </div>
    <div v-else>
      <select-sorting-bucket-overlay
        v-if="!loggedIn && !hasUserSessions && showModal"
        :bucket-options="availableBuckets"
        :loading="isStarting"
        @confirmed="handleLogin"
        @startLoading="isStarting = true"
      />
      <div v-else-if="!loggedIn && hasUserSessions">
        <user-sessions-table
          :rows="rows"
          :meta="meta"
          :data-loading="dataLoading"
          @newSorting="handleNewSorting"
          @reopenSession="handleLogin"
          @pagination-change="fetchUserSessions"
        />
      </div>
      <div v-else>
        <div>
          <b-row>
            <b-col
              cols="12"
              md="12"
            >
              <div class="d-flex justify-content-end pb-1">
                <!-- First Button (conditionally rendered) -->
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  size="md"
                  class="dispatch-button d-flex align-items-center"
                  @click="handleLogout()"
                >
                  <feather-icon
                    icon="ChevronLeftIcon"
                    class="mr-50 text-success"
                  />
                  <span class="align-middle refresh-span">Back</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="4"
            >
              <stats-card
                :value="upcoming"
                :value-new="upcomingNew"
                :value-old="upcomingOld"
                :show-sub="true"
                label="UP COMING ORDERS"
                tile-icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMGJiZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jbG9jay1hcnJvdy1kb3duLWljb24gbHVjaWRlLWNsb2NrLWFycm93LWRvd24iPjxwYXRoIGQ9Ik0xMi4zMzggMjEuOTk0QTEwIDEwIDAgMSAxIDIxLjkyNSAxMy4yMjciLz48cGF0aCBkPSJNMTIgNnY2bDIgMSIvPjxwYXRoIGQ9Im0xNCAxOCA0IDQgNC00Ii8+PHBhdGggZD0iTTE4IDE0djgiLz48L3N2Zz4="
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <stats-card
                :value="toSort"
                :value-new="toSortNew"
                :value-old="toSortOld"
                :show-sub="true"
                label="TO BE SORT"
                blob-color="#F38F3B"
                tile-icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmMzhmM2IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jbG9jay1mYWRpbmctaWNvbiBsdWNpZGUtY2xvY2stZmFkaW5nIj48cGF0aCBkPSJNMTIgMmExMCAxMCAwIDAgMSA3LjM4IDE2Ljc1Ii8+PHBhdGggZD0iTTEyIDZ2Nmw0IDIiLz48cGF0aCBkPSJNMi41IDguODc1YTEwIDEwIDAgMCAwLS41IDMiLz48cGF0aCBkPSJNMi44MyAxNmExMCAxMCAwIDAgMCAyLjQzIDMuNCIvPjxwYXRoIGQ9Ik00LjYzNiA1LjIzNWExMCAxMCAwIDAgMSAuODkxLS44NTciLz48cGF0aCBkPSJNOC42NDQgMjEuNDJhMTAgMTAgMCAwIDAgNy42MzEtLjM4Ii8+PC9zdmc+"
                @click-new="handleToSortNewClick"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <stats-card
                :value="sorted"
                :value-new="sorted"
                label="SORTED ORDERS"
                :show-sub="true"
                blob-color="#1FDA70"
                tile-icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMxZmRhNzAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jaXJjbGUtY2hlY2stYmlnLWljb24gbHVjaWRlLWNpcmNsZS1jaGVjay1iaWciPjxwYXRoIGQ9Ik0yMS44MDEgMTBBMTAgMTAgMCAxIDEgMTcgMy4zMzUiLz48cGF0aCBkPSJtOSAxMSAzIDNMMjIgNCIvPjwvc3ZnPg=="
              />
            </b-col>
          </b-row>

          <!-- Process & Scan -->
          <b-row>
            <b-col
              cols="12"
              md="12"
            >
              <process-order-form
                :date.sync="date"
                :sorting-id.sync="sortingId"
                :category.sync="category"
                :bucket.sync="bucket"
                :bucket-name.sync="bucketName"
              />
            </b-col>
          </b-row>
          <scan-order
            :location="currentLocation"
            :full-path="fullPath"
            :bucket-color="bucketColor"
            :scan-status="scanStatus"
            :scan-msg="scanMsg"
            @scan="handleScan"
          />

          <!-- Buckets -->
          <bucket-grid
            :buckets="buckets"
            :is-report="false"
            :sorting-string="sortingId"
          />
        </div>
      </div>
    </div>
    <view-to-sort-new-modal ref="viewToSortNewModal" />
  </div>
</template>

<script>
import {
  BRow, BCol, BSpinner, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StatsCard from '@/components/Sorting/StatsCard.vue'
import ProcessOrderForm from '@/components/Sorting/ProcessOrderForm.vue'
import ScanOrder from '@/components/Sorting/ScanOrder.vue'
import BucketGrid from '@/components/Sorting/BucketGrid.vue'
import UserSessionsTable from '@/components/Sorting/UserSessionsTable.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SelectSortingBucketOverlay from '@/components/Sorting/SelectSortingBucketOverlay.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import SuccessBell from '@core/mixins/SuccessBell'
import ErrorBell from '@core/mixins/ErrorBell'
import deviceRepository from '@/repository/deviceRepository'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ViewToSortNewModal from '@/components/Sorting/ViewToSortNewModal.vue'
import { connectMQTT, sendTrigger } from '@/repository/mqttRepository'

const sortingRepository = RepositoryFactory.get('sorting')

export default {
  directives: {
    Ripple,
  },
  components: {
    StatsCard,
    ProcessOrderForm,
    ScanOrder,
    BucketGrid,
    BRow,
    BCol,
    BSpinner,
    BButton,
    SelectSortingBucketOverlay,
    UserSessionsTable,
    ViewToSortNewModal,
  },
  mixins: [SuccessMessage, ErrorMessage, SuccessBell, ErrorBell],
  data: () => ({
    loading: true, // Add loading state
    loggedIn: false,
    dataLoading: false,
    upcoming: 0,
    upcomingNew: 0,
    upcomingOld: 0,
    toSort: 0,
    toSortNew: 0,
    toSortOld: 0,
    sorted: 0,
    availableBuckets: [],
    date: new Date(),
    sortingId: '',
    category: 'Night Operations',
    bucket: '149',
    currentLocation: 'Waiting...',
    fullPath: [],
    buckets: [],
    bucketName: '',
    scanStatus: -1,
    scanMsg: '',
    scanCode: '',
    scanBucket: '',
    scanWaybill: '',
    isStarting: false,
    hideCloseBucket: false,
    bucketColor: 'rgb(115, 103, 240)', // default color
    hasUserSessions: false,
    meta: {},
  }),
  mounted() {
    this.checkExistingLogin()
    connectMQTT()
  },
  methods: {
    /**
     * Handle scan event triggered from ScanOrder component
     */
    async handleScan(scanCode) {
      // Reset variables to initial state
      this.currentLocation = ''
      this.bucketColor = '#7367F0'
      this.fullPath = []
      this.scanStatus = -1
      this.scanMsg = ''

      try {
        // console.log('[Scan Operation] Scanning waybill:', scanCode)
        const response = await sortingRepository.scanWaybill({
          waybill_number: scanCode,
        })
        if (response.data?.data?.next_node) {
          this.currentLocation = response.data.data.next_node.name
        }
        this.bucketColor = response.data?.data?.next_node?.color || '#7367F0'
        this.fullPath = response.data?.data?.full_path ?? []
        this.scanStatus = response.data?.scan_status ?? -1
        this.scanMsg = response.data?.message ?? ''

        // Refresh stats and buckets after scan
        this.fetchStats()

        if (this.scanStatus === 1) {
          // console.log('[Scan Operation] Successful scan, status:', this.scanStatus)
          // Only trigger device light on successful scan and if next_node has device_ip and has_device
          const nextNode = response.data?.data?.next_node
          if (nextNode?.device_ip && nextNode?.has_device) {
            const deviceResult = await deviceRepository.triggerDevice(nextNode.device_ip)

            if (nextNode.mqtt_ip) {
              sendTrigger(nextNode.mqtt_ip, nextNode.name)
            }

            if (!deviceResult.success) {
              // console.log('[Scan Operation] Device trigger failed')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Warning',
                  text: 'Could not signal device light',
                  icon: 'AlertTriangleIcon',
                  variant: 'warning',
                },
              })
            }
          } else {
            // console.log('[Scan Operation] No device_ip in response, skipping trigger')
          }
          this.ringSuccessBell()
        } else {
          // console.log('[Scan Operation] Failed scan, status:', this.scanStatus)
          this.ringErrorBell()
        }
      } catch (error) {
        // console.log(error)
        // this.scanMsg = error.response.data?.message ?? ''
        this.convertAndNotifyError(error)
      }
    },
    async checkExistingLogin() {
      try {
        const response = await sortingRepository.getCurrentBucketSession()

        // CASE 1: Existing active login session
        if (response.data?.bucket_node_id) {
          this.bucketName = response.data.bucket_name
          this.bucket = response.data.bucket_node_id.toString()
          this.sortingId = response.data.sorting_id
          this.date = response.data.date
          this.loggedIn = true
          this.hasUserSessions = true
          this.showModal = false
          await this.fetchStats()
        } else {
        // CASE 2: No active login — check old sessions
          await this.fetchUserSessions({ page: 1, perPage: 20 })

          if (this.rows.length > 0) {
          // CASE 2a: Show UserSessionsTable
            this.hasUserSessions = true
            this.loggedIn = false
          } else {
          // CASE 2b: No old sessions — show bucket overlay
            this.hasUserSessions = false
            this.loggedIn = false
            await this.fetchBuckets()
            this.showModal = true
          }
        }
      } catch (error) {
      // Fallback to overlay on error
        this.hasUserSessions = false
        this.loggedIn = false
        await this.fetchBuckets()
        this.showModal = true
      } finally {
        this.loading = false
      }
    },
    async fetchUserSessions({ page, perPage }) {
      this.dataLoading = true
      try {
        const { data } = await sortingRepository.getUserSessions(page, perPage)
        this.rows = data.data
        this.meta = data.meta
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.dataLoading = false
    },
    async handleNewSorting() {
      await this.fetchBuckets()
      this.showModal = true
      this.loggedIn = false
      this.hasUserSessions = false
    },
    async fetchBuckets() {
      try {
        const response = await sortingRepository.getAvailableBuckets()
        this.availableBuckets = (response.data.data ?? []).map(bucket => ({
          value: bucket.id.toString(),
          text: `${bucket.name} (${bucket.key})`,
          key: bucket.key,
          name: bucket.name,
        }))
      } catch (error) {
        // console.error('Error fetching available buckets', error)
      }
    },
    async fetchStats() {
      try {
        const bucketNodeId = this.bucket || 0 // fallback if not selected
        if (!bucketNodeId) return

        const reqRes = await sortingRepository.getBucketStats(bucketNodeId)
        const response = reqRes.data
        this.upcomingNew = response.data?.upcoming_new_orders ?? 0
        this.upcomingOld = response.data?.upcoming_old_orders ?? 0
        this.upcoming = this.upcomingNew + this.upcomingOld
        this.toSortNew = response.data?.to_be_sorted_new_orders ?? 0
        this.toSortOld = response.data?.to_be_sorted_old_orders ?? 0
        this.toSort = this.toSortNew + this.toSortOld

        // Hide close bucket button if upcoming or toSort is greater than 0
        this.hideCloseBucket = this.upcoming > 0 || this.toSort > 0
        this.sorted = response.data?.sorted_orders ?? 0

        this.buckets = (response.data?.child_buckets ?? []).map(bucket => ({
          id: bucket.bucket_id,
          name: bucket.bucket_name,
          key: bucket.bucket_key,
          count: bucket.count,
          bag_name: bucket.latest_bag_display_name || 'Bag',
          bag_count: bucket.latest_bag_count || 0,
          device_ip: bucket.device_ip,
          is_leaf: bucket.is_leaf,
        }))
      } catch (error) {
        // console.error('Failed to fetch stats:', error)
      }
    },
    async loginToBucket(bucketNodeId, sortingId, date) {
      try {
        const response = await sortingRepository.loginBucket({
          bucket_node_id: bucketNodeId,
          sorting_id: sortingId,
          date,
        })
        this.bucket = bucketNodeId.toString()
        this.showSuccessMessage('Opened bucket successfully!')
        return response.data
      } catch (error) {
        this.showErrorMessage('Failed to login to bucket.')
        throw error
      }
    },
    async handleLogin({
      date, bucket, bucketName, sortingId,
    }) {
      try {
        const bucketNodeId = Number(bucket) // depends if your bucket value is ID or KEY
        await this.loginToBucket(bucketNodeId, sortingId, date)
        this.fetchStats()
        this.date = date
        this.bucket = bucket
        this.bucketName = bucketName
        this.sortingId = sortingId
        this.loggedIn = true
        this.showModal = false
      } catch (error) {
        // console.error(error)
      } finally {
        this.isStarting = false
      }
    },
    async handleLogout() {
      const result = await this.$swal({
        icon: 'question',
        title: 'Are You Sure ?',
        text: 'You want to go back from this bucket ?',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes, Go Back!',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-secondary',
        },
        buttonsStyling: false,
      })
      if (result.isConfirmed) {
        await this.logoutFromBucket(this.bucket)
      }
    },
    async logoutFromBucket(bucketNodeId) {
      try {
        const response = await sortingRepository.logoutBucket({
          bucket_node_id: bucketNodeId,
        })
        // this.showSuccessMessage('Closed bucket successfully!')
        // Reset component state and reload
        this.loggedIn = false
        this.hasUserSessions = false
        this.loading = true
        await this.checkExistingLogin()
        return response.data
      } catch (error) {
        this.showErrorMessage('Failed to login to bucket.')
        throw error
      }
    },
    handleToSortNewClick() {
      this.$refs.viewToSortNewModal.openModal(this.bucket, this.bucketName)
    },
  },
}
</script>
<style scoped>
.close-bucket {
  background-color: #fff !important;
  border: #fff !important;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  color: rgb(186, 0, 0) !important;
  font-weight: 500 !important;
}
.dispatch-button {
  background-color: #fff !important;
  border: #fff !important;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  color: rgb(28, 0, 152) !important;
  font-weight: 500 !important;
}
</style>
